import { Prismic, isEmptyText } from '@landsbankinn/prismic';
import { Row, Column, Segment } from '@landsbankinn/ui';
import React from 'react';
import { Infogram } from '../components/infogram/Infogram';

interface IProps {
  infogramid: Prismic.RichText;
  infogramid_2: Prismic.RichText;
  infogramid_3: Prismic.RichText;
}

export const InfogramContainer = ({
  infogramid,
  infogramid_2,
  infogramid_3,
}: IProps) => {
  if (isEmptyText(infogramid)) {
    return null;
  }
  const item2 = !isEmptyText(infogramid_2) ? Prismic.text(infogramid_2) : null;
  const item3 = !isEmptyText(infogramid_3) ? Prismic.text(infogramid_3) : null;
  const source = Prismic.text(infogramid);

  if (item2 && !item3) {
    return (
      <Segment>
        <Row>
          <Column md={{ width: 6 / 12 }}>
            <Infogram url={source ?? undefined} isSmaller />
          </Column>
          <Column md={{ width: 6 / 12 }}>
            <Infogram url={item2} isSmaller />
          </Column>
        </Row>
      </Segment>
    );
  }

  if (item2 && item3) {
    return (
      <Segment>
        <Row>
          <Column md={{ width: 6 / 12 }} lg={{ width: 4 / 12 }}>
            <Infogram url={source ?? undefined} isSmaller />
          </Column>
          <Column md={{ width: 6 / 12 }} lg={{ width: 4 / 12 }}>
            <Infogram url={item2} isSmaller />
          </Column>
          <Column md={{ width: 6 / 12 }} lg={{ width: 4 / 12 }}>
            <Infogram url={item3} isSmaller />
          </Column>
        </Row>
      </Segment>
    );
  }

  return (
    <Segment>
      <Infogram url={source ?? undefined} background="Grey" />
    </Segment>
  );
};
